<template>

    <ed-modal class="invoice-email-form" title="Invoice Email" :show="show" @close="$emit('close')" type="small-medium">
      <div slot="body" class="invoice-email-form">
        <div>
            <router-link
            :to="{ path: '/d/Invoice/review-email', query: { invoiceId: paymentInvoiceId } }"
            target="_blank"
            class="open-link"
            >
            <i class="fa fa-share-square"></i> Open in new tab
            </router-link>
        </div>

        <!-- Sender -->
        <div>
            <p class="email-label">Sender</p>
            <p class="email-content">{{ emailData.FromEmail }}</p>
        </div>

        <!-- Subject -->
        <div>
            <p class="email-label">Subject</p>
            <p class="email-content">{{ emailData.Subject }}</p>
        </div>

        <!-- Date -->
        <div>
            <p class="email-label">Date</p>
            <p class="email-content">{{ formatDate(emailData.ReceivedDate)}}</p>
        </div>

        <!-- Body -->
        <div>
          <div>
            <p class="email-label">Body</p>
                <div class="email-list" v-html="emailData.OriginalBodyHtml"></div>

          </div>
        </div>

        <!-- Footer Info -->
        <div >
          <div >
            
          </div>
        </div>

      </div>
      
      <div slot="footer" >
        <button type="button" class="btn btn-primary" @click="$emit('close')">
          CLOSE
        </button>
      </div>
      
    </ed-modal>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    paymentInvoiceId: {
      type: [String, Number],
      default: null
    },
    emailData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      const timestamp = parseInt(dateString.match(/\d+/)[0], 10)
      return new Date(timestamp).toLocaleString()
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-email-form {
  text-align: left !important;
  
  ::v-deep .modal-body {
    overflow-x: hidden;
    word-wrap: break-word;
  }
}

.email-label {
  font-weight: bold;
  font-size: 1em;
  margin-bottom: 5px;
}

.email-content {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 100%;
  margin-bottom: 15px;
}

.email-list {
  overflow-wrap: break-word;
  word-break: normal;
  white-space: pre-wrap;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  
  * {
    white-space: pre-wrap !important;
    word-break: normal !important;
    overflow-wrap: break-word !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    display: block !important;
  }
  
  p, div, span, li {
    white-space: pre-wrap !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    word-break: normal !important;
    max-width: 100% !important;
    display: block !important;
  }
  
  span, b, strong, em, i {
    display: inline !important;
    white-space: pre-wrap !important;
  }
  
  table {
    table-layout: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    word-break: normal !important;
  }
  
  td, th {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    white-space: pre-wrap !important;
    word-break: normal !important;
  }
  
  a {
    word-break: break-all !important;
    overflow-wrap: break-word !important;
    white-space: pre-wrap !important;
  }
  
  ul, ol {
    padding-left: 20px !important;
    max-width: 100% !important;
  }
  
  li {
    white-space: pre-wrap !important;
    word-break: normal !important;
    max-width: calc(100% - 20px) !important;
    margin-bottom: 5px !important;
  }
}

::v-deep .modal-dialog {
  max-width: 90vw;
  word-wrap: break-word;
}

::v-deep .modal-content {
  overflow-x: hidden;
  word-wrap: break-word;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/ReviewEmailModal.vue